function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyPinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "44px",
    height: "56px",
    viewBox: "0 0 44 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44 21.777344 C 44 33.808594 22 56 22 56 C 22 56 0 33.808594 0 21.777344 C 0 15.972656 2.304688 10.476562 6.496094 6.429688 C 10.582031 2.28125 16.132812 0 22 0 C 27.867188 0 33.417969 2.28125 37.503906 6.429688 C 41.695312 10.476562 44 15.972656 44 21.777344 Z M 44 21.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(43.921569%,43.921569%,43.921569%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 18.099076 50.101438 C 16.100497 47.897894 13.497869 44.899567 10.89897 41.501966 C 8.300071 38.100598 5.697443 34.39789 3.702592 30.800651 C 1.700284 27.199646 0.499645 23.802044 0.499645 20.999588 C 0.499645 15.601846 2.699574 10.30204 6.499112 6.501397 C 10.302379 2.700754 15.600852 0.500977 20.999999 0.500977 C 26.399147 0.500977 31.69762 2.700754 35.500887 6.501397 C 39.300425 10.30204 41.500354 15.601846 41.500354 20.999588 C 41.500354 23.802044 40.19904 27.199646 38.297406 30.800651 C 36.302556 34.39789 33.699928 38.100598 31.101029 41.501966 C 28.50213 44.899567 25.899502 47.897894 23.900923 50.101438 L 20.999999 53.197701 Z M 18.099076 50.101438 ",
    transform: "matrix(1.047619,0,0,1.037037,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,62.745098%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 33.417969 9.332031 L 10.476562 9.332031 L 10.476562 16.902344 L 33.417969 16.902344 Z M 33.417969 9.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 33.417969 18.5625 L 10.476562 18.5625 L 10.476562 26.132812 L 33.417969 26.132812 Z M 33.417969 18.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 10.476562 28.105469 L 10.476562 31.628906 L 11.207031 31.628906 L 11.207031 30.074219 L 12.78125 30.074219 L 12.78125 29.347656 L 11.207031 29.347656 L 11.207031 28.726562 L 12.78125 28.726562 L 12.78125 28 L 10.476562 28 Z M 10.476562 28.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 14.878906 31.109375 C 14.878906 30.800781 14.878906 30.28125 14.878906 29.972656 C 14.878906 29.554688 14.664062 29.140625 13.828125 29.140625 C 13.511719 29.140625 13.199219 29.246094 12.988281 29.246094 L 12.988281 29.867188 C 13.199219 29.765625 13.410156 29.660156 13.726562 29.660156 C 13.933594 29.660156 14.140625 29.765625 14.140625 29.972656 C 14.039062 29.972656 13.933594 29.867188 13.726562 29.867188 C 13.097656 29.867188 12.675781 30.179688 12.675781 30.800781 C 12.675781 31.421875 13.199219 31.628906 13.511719 31.628906 C 13.726562 31.628906 13.933594 31.523438 14.140625 31.421875 C 14.140625 31.523438 14.140625 31.523438 14.25 31.628906 L 14.980469 31.628906 C 14.980469 31.523438 14.878906 31.421875 14.878906 31.109375 Z M 13.511719 30.800781 C 13.511719 30.589844 13.726562 30.488281 13.933594 30.488281 C 14.039062 30.488281 14.140625 30.488281 14.25 30.589844 C 14.25 30.695312 14.25 30.902344 14.25 31.007812 C 14.140625 31.109375 14.039062 31.109375 13.933594 31.109375 C 13.621094 31.109375 13.511719 30.902344 13.511719 30.800781 Z M 13.511719 30.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 29.75 31.109375 C 29.75 30.800781 29.75 30.28125 29.75 29.972656 C 29.75 29.554688 29.542969 29.140625 28.707031 29.140625 C 28.390625 29.140625 28.074219 29.246094 27.867188 29.246094 L 27.867188 29.867188 C 28.074219 29.765625 28.285156 29.660156 28.597656 29.660156 C 28.808594 29.660156 29.019531 29.765625 29.019531 29.972656 C 28.914062 29.972656 28.808594 29.867188 28.597656 29.867188 C 27.96875 29.867188 27.554688 30.179688 27.554688 30.800781 C 27.554688 31.421875 28.074219 31.628906 28.390625 31.628906 C 28.597656 31.628906 28.808594 31.523438 29.019531 31.421875 C 29.019531 31.523438 29.019531 31.523438 29.121094 31.628906 L 29.859375 31.628906 C 29.859375 31.523438 29.75 31.421875 29.75 31.109375 Z M 28.390625 30.800781 C 28.390625 30.589844 28.597656 30.488281 28.808594 30.488281 C 28.914062 30.488281 29.019531 30.488281 29.121094 30.589844 C 29.121094 30.695312 29.121094 30.902344 29.121094 31.007812 C 29.019531 31.109375 28.914062 31.109375 28.808594 31.109375 C 28.496094 31.109375 28.390625 30.902344 28.390625 30.800781 Z M 28.390625 30.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 17.914062 29.140625 C 17.597656 29.140625 17.390625 29.246094 17.183594 29.453125 C 17.074219 29.246094 16.761719 29.140625 16.554688 29.140625 C 16.34375 29.140625 16.132812 29.246094 15.925781 29.347656 L 15.925781 29.140625 L 15.292969 29.140625 L 15.292969 31.628906 L 16.03125 31.628906 L 16.03125 29.972656 C 16.132812 29.867188 16.238281 29.765625 16.34375 29.765625 C 16.554688 29.765625 16.65625 29.867188 16.65625 30.179688 L 16.65625 31.628906 L 17.390625 31.628906 L 17.390625 29.972656 C 17.496094 29.867188 17.597656 29.765625 17.707031 29.765625 C 17.914062 29.765625 18.019531 29.972656 18.019531 30.179688 L 18.019531 31.628906 L 18.75 31.628906 L 18.75 29.867188 C 18.75 29.453125 18.4375 29.140625 17.914062 29.140625 Z M 17.914062 29.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 21.054688 28.105469 L 20.324219 28.105469 L 20.324219 31.628906 L 21.054688 31.628906 Z M 21.054688 28.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 25.773438 29.140625 L 24.828125 28 L 24.097656 28 L 24.097656 31.523438 L 24.828125 31.523438 L 24.828125 29.039062 L 25.773438 30.28125 L 26.714844 29.039062 L 26.714844 31.523438 L 27.445312 31.523438 L 27.445312 28 L 26.714844 28 Z M 25.773438 29.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 19.902344 29.140625 L 19.171875 29.140625 L 19.171875 31.628906 L 19.902344 31.628906 Z M 19.902344 29.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 19.589844 28 C 19.378906 28 19.171875 28.207031 19.171875 28.414062 C 19.171875 28.621094 19.378906 28.832031 19.589844 28.832031 C 19.800781 28.832031 20.011719 28.621094 20.011719 28.414062 C 20.011719 28.207031 19.800781 28 19.589844 28 Z M 19.589844 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 30.800781 29.347656 L 30.800781 29.039062 L 30.171875 29.039062 L 30.171875 31.523438 L 30.902344 31.523438 L 30.902344 30.074219 C 31.011719 29.972656 31.113281 29.867188 31.429688 29.867188 C 31.640625 29.867188 31.742188 29.972656 31.847656 29.972656 L 31.847656 29.246094 C 31.742188 29.140625 31.640625 29.140625 31.53125 29.140625 C 31.21875 29.140625 31.011719 29.140625 30.800781 29.347656 Z M 30.800781 29.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 33.207031 31.007812 C 33 31.007812 32.894531 30.800781 32.894531 30.695312 L 32.894531 29.867188 L 33.523438 29.867188 L 33.523438 29.246094 L 32.894531 29.246094 L 32.894531 28.3125 L 32.265625 28.621094 L 32.265625 29.246094 L 31.847656 29.246094 L 31.847656 29.867188 L 32.265625 29.867188 L 32.265625 30.800781 C 32.265625 31.316406 32.476562 31.734375 33.105469 31.734375 C 33.316406 31.734375 33.417969 31.734375 33.523438 31.628906 L 33.523438 30.902344 C 33.523438 30.902344 33.417969 31.007812 33.207031 31.007812 Z M 33.207031 31.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,54.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 21.894531 32.25 L 22.628906 32.25 L 23.78125 29.140625 L 23.046875 29.140625 L 22.523438 30.488281 L 22 29.140625 L 21.164062 29.140625 L 22.105469 31.421875 Z M 21.894531 32.25 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyPinLogo);
export default __webpack_public_path__ + "static/media/FamilyPinLogo.853695111c895de62b1bd7cd63518e9c.svg";
export { ForwardRef as ReactComponent };